import React, { PropsWithChildren } from "react";
import { Typography } from "@mui/material";

export enum FormInfoType {
  Success = "Success",
  Warning = "Warning",
  Danger = "Danger",
  Info = "Info"
}

const mapTypeToClass = (type: FormInfoType | string) => `alert-${type.toLowerCase()}`;

export type FormInfoProps = {
  title: string,
  subtitle?: string,
  type: FormInfoType | string,
}
const FormInfo: React.FC<PropsWithChildren<FormInfoProps>> = (props) => (
  <div
    className={`alert ${mapTypeToClass(props.type)}`}
    style={{ marginTop: "100px" }}
  >
    <Typography align="center" variant="h4">{props.title}</Typography>
    {props.subtitle && <Typography align="center" variant="subtitle1">{props.subtitle}</Typography>}
    <Typography variant="body1">{props.children}</Typography>
  </div>
);

export default FormInfo;
